import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { LayoutBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";

export const meta: ComponentMeta = {
  name: "Heading",
  version: 1,
  nameI18n: "builder_ui.block_type.form_heading",
  category: [LayoutBlock],
  props: {
    value: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      prop: "other",
      type: "string",
    },
    textType: {
      name: "Heading Type",
      nameI18n: "builder_ui.prop_type.heading_type",
      prop: "other",
      type: "select",
      defaultValue: "title",
      options: [
        {
          label: "Title",
          labelI18n: "builder_ui.prop_type.heading_types.title",
          value: "title",
        },
        {
          label: "Subtitle",
          labelI18n: "builder_ui.prop_type.heading_types.subtitle",
          value: "subtitle",
        },
      ],
    },
  },
};
